import { render, staticRenderFns } from "./sessionNewPaymentMethod.vue?vue&type=template&id=70a4a991&scoped=true"
import script from "./sessionNewPaymentMethod.vue?vue&type=script&lang=js"
export * from "./sessionNewPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./sessionNewPaymentMethod.vue?vue&type=style&index=0&id=70a4a991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4a991",
  null
  
)

export default component.exports